(function($) {
    "use strict"; // Start of use strict

    // $('.js-tab-active:not(.sub-nav__link)').on('click', function(event) {
    //     event.preventDefault();
    //     $(this).parent().toggleClass('is-open');
    // });

})(jQuery); // End of use strict
